import { Breadcrumbs, Typography } from '@otp/ui';
import { usePageContext } from 'src/context/page.context';
import {
  Actions,
  AppArea,
  Subjects,
  User,
} from 'src/graphql/generated/graphql';
import { Link, useNavigate } from 'react-router-dom';
import React from 'react';
import { Arrow, Menu } from '@otp/icons';
import clsx from 'clsx';
import styles from './mobile.module.css';
import UserNotificationsPopper from '../notification/user-notifications';
import { Can } from 'src/utils/can';

interface MobileHeaderProps {
  user?: User;
  logout: () => void;
  onMenuToggle: () => void;
}

export const MobileHeader = ({
  user,
  logout,
  onMenuToggle,
}: MobileHeaderProps) => {
  const { header, breadcrumbs } = usePageContext();
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const hasBreadcrumbs = breadcrumbs?.items?.length;

  return (
    <>
      <div
        className={clsx({
          [styles.wrapperPlaceholderWithBreadcrumbs]: hasBreadcrumbs,
          [styles.wrapperPlaceholderWithoutBreadcrumbs]: !hasBreadcrumbs,
        })}
      />
      <div className={styles.wrapper}>
        <div
          className={clsx(
            'flex items-center justify-between px-4',
            styles.titleWrapper,
          )}
        >
          <div className="flex items-center">
            <Arrow className="mr-3 cursor-pointer" onClick={goBack} />
            <Typography className={styles.title}>{header}</Typography>
          </div>

          <div className="ml-auto" />
          <Can
            I={Actions.Read}
            a={Subjects.Notifications}
            appArea={AppArea.Common}
          >
            <div className="ml-4 mr-4">
              <UserNotificationsPopper user={user} />
            </div>
          </Can>
          <div>
            <Menu className={styles.menuIcon} onClick={onMenuToggle} />
          </div>
        </div>
        {hasBreadcrumbs && (
          <div className="p-4">
            <Breadcrumbs {...breadcrumbs} Link={Link} />
          </div>
        )}
      </div>
    </>
  );
};

export default MobileHeader;
